<template>
  <div class="notif-group">
    <StatBadge
      label="Total"
      :value="notifications.total"
      variant="purple"
      tooltip="Total de notificações"
    />
    <StatBadge
      label="Pend."
      :value="notifications.unread"
      variant="yellow"
      tooltip="Notificações não lidas"
    />
    <StatBadge
      label="Resolv."
      :value="notifications.solved"
      variant="green"
      tooltip="Notificações resolvidas"
    />
  </div>
</template>

<script>
import StatBadge from "@/components/table/StatBadge.vue";

/**
 * TeacherNotificationsCell
 *
 * Célula de tabela que resume as notificações (total/pendentes/
 * resolvidas) de um professor. Específico do domínio de professores —
 * por isso vive junto da feature, não em `components/table`.
 */
export default {
  name: "TeacherNotificationsCell",

  components: { StatBadge },

  props: {
    /** Objeto `{ total, unread, solved }` vindo de `teacher.Notifications`. */
    notifications: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.notif-group {
  display: flex;
  gap: 8px;
}
</style>
